<div class="row">
  <div class="col-12">
    <ng-container *ngIf="easyMode && !loading">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group d-block">
            <div class="form-check form-switch">
              <input [ngModel]="inverted" [disabled]="disabled"
                     (ngModelChange)="toggleInverted()" type="checkbox" role="switch" class="form-check-input"
                     id="Inverted">
              <label class="form-check-label"
                     for="Inverted">{{'lang.globals.blacklist' | translate}}</label>
            </div>
            <span *ngIf="!disabled"
                  class="form-text text-muted">{{'lang.globals.blacklistDescription.company' | translate}}</span>
          </div>
        </div>
      </div>
      <div *ngFor="let booking of bookings; let i = index; first as isFirst; last as isLast"
           class="d-flex justify-content-between align-items-center border-dashed-bottom" style="padding-bottom: 1rem;
   margin-bottom: 1rem;">
        <div>
          <i>{{booking.id}}</i>
        </div>
        <div class="mx-1">
          <sb-comp-image-name-wrapper [medium]="booking?.medium" [thumbnailSize]="'S'" [still]="true">
            <span firstLine class="font-size-lg" [innerHTML]="booking?.medium?.name | truncate : 45"></span>
            <span secondLine class="text-muted font-weight-bold"
                  [innerHTML]="booking?.medium?.mediumGroup?.name | truncate : 45"></span>
          </sb-comp-image-name-wrapper>
        </div>
        <div class="mx-1">
          <sb-icon icon="marker" class="mr-1"></sb-icon>
          {{booking?.marker?.name}}
        </div>
        <div class="mx-1">
          <sb-icon icon="resolution" class="mr-1"></sb-icon>
          <span>{{booking?.marker?.resolution?.id}}</span>
        </div>
        <sb-button *ngIf="!disabled" [disabled]="false" (submitClicked)="removeBooking(i)"
                   classes="btn-danger mr-0 ml-2">
          <sb-icon icon="trash"></sb-icon>
        </sb-button>
      </div>
      <div *ngIf="!disabled" class="d-flex justify-content-center">
        <sb-button (submitClicked)="addBookingRow()" classes="btn-primary m-0">
          + {{'lang.globals.addBooking' | translate}}</sb-button>
      </div>
    </ng-container>
    <ng-container> <!-- *ngIf="!easyMode"> -->
      <sb-filter-definition [disabled]="disabled" [preselectType]="true" [isInModalContext]="false" *ngIf="cull"
                            [(cull)]="cull" (cullChange)="emitChange($event)">
      </sb-filter-definition>
    </ng-container>
  </div>
</div>
